/* global bocAmchart4, am4charts, am4maps, chartLanguage, am4core, AmCharts */

/**
 * Adds graph to a chart object
 *
 * @param {object} chart object
 * @param {string} xAxisType "date", "text" or "number"
 * @param {string} defaultType type to use if type is not set in shortcode
 * @param {string|string[]} series name[s]
 * @param {string} label to use in chart

 * @param {int} id for this graph
 * @returns {string}        the proper string including the quarter
 */
bocAmchart4.addGraph = function (
    chart,
    xAxisType,
    defaultType,
    series,
    label,
    id
) {
    let idx;
    if (typeof id !== 'undefined' && typeof chart.series[id] === 'undefined') {
        idx = id;
    } else {
        for (let index = 0; index < 100; index++) {
            if (typeof chart.series[index] === 'undefined') {
                idx = index;
                break;
            }
        }
    }
    let thisLabel = label;
    thisLabel = bocAmchart4.getBocSetting(chart, 'label', idx, thisLabel);
    thisLabel = bocAmchart4.processStyleTags(thisLabel);

    if (chart.bocSettings.args.hasOwnProperty("xaxistype")) {
        xAxisType = chart.bocSettings.args.xaxistype;
    }

    let yAxisType = "number";
    if (chart.bocSettings.args.hasOwnProperty("yaxistype")) {
        yAxisType = chart.bocSettings.args.yaxistype;
    }

    let defaultTypeByAxis;
    switch (xAxisType) {
        case 'date':
        case 'time':
            defaultTypeByAxis = 'line';
            break;
        case 'text':
            defaultTypeByAxis = 'column';
            break;
        case 'number':
            if (yAxisType === 'text') {
                defaultTypeByAxis = 'column';
            } else {
                defaultTypeByAxis = 'scatter';
            }
            break;
    }
    let thisType = defaultType ? defaultType : defaultTypeByAxis;

    if (chart.bocSettings.args.hasOwnProperty('defaulttype')) {
        thisType = chart.bocSettings.args['defaulttype'];
    }

    thisType = bocAmchart4.getBocSetting(chart, 'type', idx, thisType);

    let thisColor = bocAmchart4.getBocSetting(chart, 'color', idx, false);

    if (thisColor) {
        if (thisColor.slice(0, 1) === '#') {
            thisColor = am4core.color(thisColor);
        } else if (!isNaN(thisColor)) {
            thisColor = chart.colors.list[parseInt(thisColor)];
        } else {
            thisColor = false;
        }
    }

    let thisColumnWidth = bocAmchart4.getBocSetting(chart, 'columnwidth', idx, false);
    let thisStacked = bocAmchart4.getBocSetting(chart, 'stacked', idx, false) === "true";

    let thisAxis = false;
    let axisID = "left";
    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'axis')) {
        axisID = chart.bocSettings.args['series' + idx + 'axis'];
    }
    if (typeof chart.yAxes === 'object') {
        chart.yAxes.values.forEach(function (axis) {
            if (axis.id === axisID) {
                thisAxis = axis;
            }
        });
    }

    let defaults = {
        "column": {
            "fillAlphas": 0.8,
            "strokeWidth": 0,
            "lineAlpha": 0,
            "zIndex": 2
        },
        "candlestick": {
            "fillAlphas": 0.8,
            "strokeWidth": 0,
            "lineAlpha": 0,
            "zIndex": 2
        },
        "band": {
            "strokeWidth": 0,
            "lineAlpha": 0,
            "fillOpacity": 0.3,
            "zIndex": 2
        },
        "scatter": {
            "strokeWidth": 0,
            "zIndex": 4
        },
        "fill": {
            "strokeWidth": 0,
            "fillOpacity": 0.8
        },
        "step": {
            "strokeWidth": 2,
            "zIndex": 6
        },
        "steppedFill": {
            "strokeWidth": 0,
            "fillOpacity": 0.8
        },
        "line": {
            "strokeWidth": 2,
            "zIndex": 6
        },
        "marker": {
            "strokeWidth": 2,
            "zIndex": 6
        },
        "bullet": {
            "strokeWidth": 0,
            "zIndex": 4
        }

    };

    let seriesObj;
    let chartType = 'xy';
    if (chart.bocSettings.hasOwnProperty('type')) {
        chartType = chart.bocSettings.type;
    }

    switch (chartType) {
        case 'xy': {
            let toolTipObj;
            let useCursor = typeof chart.cursor === "object";


            chart.events.on('layoutvalidated', () => {

                // PARAMETER data-seriesXopacity
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'opacity')) {
                    let opacity = chart.bocSettings.args['series' + idx + 'opacity'];
                    seriesObj.strokeOpacity = opacity;
                    if (['column', 'candlestick', 'fill', 'band', 'steppedFill'].includes(thisType)) {
                        seriesObj.fillOpacity = opacity;
                    }
                }
                let seriesArgs = Object.keys(chart.bocSettings.args)
                    .filter(key => key.startsWith('series'))
                    .reduce((res, key) => ((res[key] = chart.bocSettings.args[key]), res), {});

                let argNames = Object.keys(seriesArgs);

                //an array to keep track of which seriesIndices we have considered already
                let computedSeries = [];
                //for each parameter get the number directly following the string 'series'
                for (let ind = 0; ind < argNames.length; ind++) {
                    //idxString is the remainder of the string from the argument name. (e.g. color, tooltipText)
                    let idxString = argNames[ind].slice(6, argNames[ind].length);
                    if (!idxString || !idxString.match(/\d+/)) {
                        continue;
                    }
                    let seriesIdx = parseInt(idxString.match(/\d+/)[0]);

                    //if we have already considered this seriesIndex, skip its relevant parameters
                    if (seriesIdx in computedSeries) {
                        continue;
                    }

                    /**
                     * A conditional to replace the labels associated with both the pointer to the chart and the legend
                     * see params documentation for data-series{0|1|..}legendtext for further clarification
                     */
                    if (chart.bocSettings.args.hasOwnProperty('series' + seriesIdx + 'legendtext')) {
                        if (seriesIdx > seriesObj.dataItems.length) {
                            return;
                        }

                        //update the text of the legend associated with the category
                        let seriesLegendLabel = chart.legend.dataItems.getIndex(seriesIdx);
                        if (!seriesLegendLabel) {
                            return;
                        }
                        seriesLegendLabel.label.text = chart.bocSettings.args['series' + seriesIdx + 'legendtext'];
                    }
                    //adding in this series to the list of computed series, as to not repeat these conditionals
                    computedSeries.push(seriesIdx);
                }
            });
            switch (thisType) {
                case "column":
                case "candlestick":
                    seriesObj = chart.series.push(new am4charts.ColumnSeries());
                    toolTipObj = useCursor ? seriesObj : seriesObj.columns.template;

                    if (chart.bocSettings.args.hasOwnProperty("showcolumnlabels")) {
                        let columnLabel = seriesObj.columns.template.createChild(am4core.Label);

                        columnLabel.textAlign = "middle";
                        columnLabel.hideOversized = true;
                        columnLabel.text = "{valueY}";
                        if (chart.bocSettings.args.hasOwnProperty("columnlabelsfontsize")) {
                            columnLabel.fontSize = chart.bocSettings.args.columnlabelsfontsize;
                        }
                        if (chart.bocSettings.args.hasOwnProperty("rotatecolumnlabels")) {
                            columnLabel.rotation = 90;
                        }

                        if (chart.bocSettings.args.hasOwnProperty("columnlabeltext")) {
                            columnLabel.text = chart.bocSettings.args.columnlabeltext;
                        }

                        if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'columnlabeltext')) {
                            columnLabel.text = chart.bocSettings.args['series' + idx + 'columnlabeltext'];
                        }

                        let wrapLines = 3;
                        if (chart.bocSettings.args.hasOwnProperty("wrapcolumnlabels")) {
                            columnLabel.truncate = false;
                            columnLabel.wrap = true;
                            if (!isNaN(chart.bocSettings.args.wrapcolumnlabels)) {
                                wrapLines = parseInt(chart.bocSettings.args.wrapcolumnlabels);
                            }
                        } else {
                            columnLabel.truncate = false;
                            columnLabel.wrap = false;
                        }

                        if (chart.bocSettings.args.showcolumnlabels === 'top') {
                            // eslint-disable-next-line id-length
                            columnLabel.x = am4core.percent(50);
                            // eslint-disable-next-line id-length
                            columnLabel.y = am4core.percent(0);
                            columnLabel.horizontalCenter = "middle";
                            columnLabel.verticalCenter = "bottom";
                            columnLabel.maxHeight = wrapLines * 16;
                        } else {
                            // eslint-disable-next-line id-length
                            columnLabel.x = am4core.percent(50);
                            // eslint-disable-next-line id-length
                            columnLabel.y = am4core.percent(50);
                            columnLabel.horizontalCenter = "middle";
                            columnLabel.verticalCenter = "middle";
                            if (thisColor) {
                                columnLabel.fill = thisColor.alternative;
                            } else {
                                columnLabel.fill = seriesObj.fill.alternative;
                            }
                        }

                        seriesObj.columns.template.events.on("sizechanged", function (ev) {
                            if (ev.target.children) {
                                let columnLabel = ev.target.children.getIndex(1);
                                columnLabel.maxWidth = ev.target.pixelWidth;
                                if (chart.bocSettings.args.showcolumnlabels === 'top'
                                    || ev.target.pixelHeight > wrapLines * 16) {
                                    columnLabel.maxHeight = wrapLines * 16;
                                } else {
                                    columnLabel.maxHeight = ev.target.pixelHeight;
                                }
                                columnLabel.invalidate();
                            }
                        });
                    }

                    break;
                case "step":
                case "steppedFill":
                    seriesObj = chart.series.push(new am4charts.StepLineSeries());
                    toolTipObj = useCursor ? seriesObj : seriesObj.bullets.template;
                    break;
                // Expected to get here for: "line", "marker", "scatter", "fill"
                default:
                    seriesObj = chart.series.push(new am4charts.LineSeries());
                    if (thisType === 'bullet' || thisType === 'scatter') {
                        toolTipObj = useCursor ? seriesObj : seriesObj.bullets.template;
                    } else {
                        toolTipObj = seriesObj;
                    }
            }

            let blend = false;
            if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'blend')) {
                blend = parseFloat(chart.bocSettings.args['series' + idx + 'blend']);
            }
            if (thisColor) {
                if (blend !== false) {
                    thisColor = thisColor.lighten(blend);
                }
                seriesObj.fill = thisColor;
                seriesObj.stroke = thisColor;
            } else {
                if (blend !== false) {
                    seriesObj.fill = seriesObj.fill.lighten(blend);
                }
            }
            if (blend !== false) {
                let cid = chart.bocSettings.id;
                bocAmchart4.vars[cid].blendColor = bocAmchart4.vars[cid].blendColor || [];
                bocAmchart4.vars[cid].blendColor[idx] = {
                    "idx": idx,
                    "color": seriesObj.fill
                };
            }

            let separator = (chartLanguage === "fr") ? " – " : "—";

            if (thisType === 'candlestick' || thisType === 'band') {
                if (xAxisType === 'number') {
                    if (yAxisType === 'number') {
                        // This is the case of number xAxis and band / candlestick with numeric y axis
                        // Case of making a vertical band is not implemented
                        seriesObj.dataFields.valueX = series[0];
                        seriesObj.dataFields.valueY = series[2];
                        seriesObj.dataFields.openValueY = series[1];
                        toolTipObj.tooltipText = thisLabel + ":" + " {openValueY}" + separator + "{valueY}";
                    } else {
                        seriesObj.dataFields.valueX = series[1];
                        seriesObj.dataFields.openValueX = series[0];
                        toolTipObj.tooltipText = thisLabel + ":" + " {openValueX}" + separator + "{valueX}";
                    }
                } else {
                    seriesObj.dataFields.valueY = series[1];
                    seriesObj.dataFields.openValueY = series[0];
                    toolTipObj.tooltipText = thisLabel + ":" + " {openValueY}" + separator + "{valueY}";
                }
            }

            if (thisType === 'column') {
                toolTipObj.tooltipText = thisLabel + ":" + " {valueX}";
            }

            // Set legendPeriodValueText if the legend exists
            if (chart.legend && chart.bocSettings.args.hasOwnProperty("legendperiodvaluetext")) {
                let arg = '';
                let input = chart.bocSettings.args.legendperiodvaluetext;

                // Get the prefix (open, close, high, low)
                let prefix = input.substring(0, input.indexOf('.'));

                // get the suffix (open, close, high, low, sum, average, count)
                let suffix = input.substring(input.indexOf('.') + 1);

                if (prefix === "value") {
                    arg = '{valueY.' + suffix + '}';
                } else {
                    arg = '{' + prefix + '.' + suffix + '}';
                }

                seriesObj.legendSettings.valueText = arg;

                // itemValueText shows the value of the series that the mouse is hovered over.
                seriesObj.legendSettings.itemValueText = '{valueY}';

                chart.legend.valueLabels.template.fontSize = '0.875em';

                // hide the value text when the series is disabled
                let as2 = chart.legend.valueLabels.template.states.getKey("active");
                as2.properties.opacity = 0;
            }

            // Need to change this based on chart type, if not date
            if (xAxisType === "date") {
                seriesObj.dataFields.dateX = "date";
            } else if (xAxisType === "time") {
                seriesObj.dataFields.valueX = "date";
            } else if (xAxisType === "text") {
                seriesObj.dataFields.categoryX = "category";
            } else if (xAxisType === "number") {
                if (typeof series === 'object') {
                    if (yAxisType === 'text') {
                        seriesObj.dataFields.valueX = series[1];
                    } else {
                        seriesObj.dataFields.valueX = series[0];
                    }
                } else {
                    seriesObj.dataFields.valueX = series;
                }
            } else {
                // should not really get here, but let's keep it for now
                seriesObj.dataFields.valueX = xAxisType;
            }

            if (yAxisType === "date") {
                seriesObj.dataFields.dateY = "date";
            } else if (yAxisType === "time") {
                seriesObj.dataFields.valueY = "date";
            } else if (yAxisType === "text") {
                seriesObj.dataFields.categoryY = "category";
                if (thisType !== 'candlestick' && thisType !== 'band') {
                    toolTipObj.tooltipText = "{valueX}" + separator + thisLabel;
                }
            } else if (yAxisType === "number") {
                if (thisType !== 'candlestick' && thisType !== 'band') {
                    if (typeof series === 'object') {
                        seriesObj.dataFields.valueY = series[1];
                        toolTipObj.tooltipText = "{valueX}, {valueY}" + separator + thisLabel;
                    } else {
                        seriesObj.dataFields.valueY = series;
                        toolTipObj.tooltipText = "{valueY}" + "{" + series + "_R}" + separator + thisLabel;
                    }
                }
            } else {
                // should not really get here, but let's keep it for now
                seriesObj.dataFields.valueY = yAxisType;
            }

            if (xAxisType === 'number' && yAxisType === 'number' && thisType === 'column') {
                seriesObj.xAxis = chart.xAxes.getIndex(0);
            }

            let yAxis = 'left';
            if (thisAxis) {
                seriesObj.yAxis = thisAxis;
                yAxis = thisAxis.id;
            }

            let stackedAxisId = false;
            let xStacked = xAxisType === "number" && chart.bocSettings.args.hasOwnProperty('bottomaxisstacktype');
            let yStacked = yAxisType === "number" && chart.bocSettings.args.hasOwnProperty(yAxis + 'axisstacktype');
            if (yStacked) {
                stackedAxisId = yAxis;
            } else if (xStacked) {
                stackedAxisId = 'bottom';
            }
            if (stackedAxisId) {
                let unStacked = bocAmchart4.getBocSetting(chart, 'stacked', idx, true) === "false";
                seriesObj.stacked = !unStacked;
                if (chart.bocSettings.args[stackedAxisId + 'axisstacktype'] === "100%") {
                    if (xStacked) {
                        seriesObj.dataFields.valueXShow = "totalPercent";
                    } else {
                        seriesObj.dataFields.valueYShow = "totalPercent";
                    }
                }
            }

            seriesObj.name = thisLabel;
            bocAmchart4.initChartVars(chart);

            // Probably need a parameter to select the series to display in scrollbar
            if (parseInt(chart.bocSettings.args.categoryscrollbar) === idx) {
                bocAmchart4.vars[chart.bocSettings.id]['scrollBarSeries'] = seriesObj;
            }

            let shapes = [
                {"class": 'Circle', 'size': 7},
                {"class": 'Triangle', 'size': 7},
                {"class": 'Rectangle', 'rotation': 45, 'size': 7},
                {"class": 'Rectangle', 'size': 7},
                {"class": 'Triangle', 'rotation': 180, 'size': 7},
                {"class": 'Triangle', 'rotation': 270, 'size': 7},
                {"class": 'Triangle', 'rotation': 90, 'size': 7}
            ];

            if (thisType === "column" || thisType === "fill") {
                if (thisStacked) {
                    seriesObj.stacked = true;
                }
                // Pattern Implementation
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'pattern')) {
                    let thisPattern = chart.bocSettings.args['series' + idx + 'pattern'];
                    if (thisColor) {
                        seriesObj.fill = bocAmchart4.getPattern(thisColor, thisPattern, 1);
                    } else {
                        thisColor = am4core.color(seriesObj.fill.hex);
                        seriesObj.fill = bocAmchart4.getPattern(seriesObj.fill.hex, thisPattern, 1);
                    }

                    if (thisType === "column") {
                        let startCategory = false;
                        if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'patternstart')) {
                            startCategory = chart.bocSettings.args['series' + idx + 'patternstart'];
                            bocAmchart4.vars[chart.bocSettings.id]['series' + idx + 'patternstart'] = startCategory;
                        }

                        let endCategory = false;
                        if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'patternend')) {
                            endCategory = chart.bocSettings.args['series' + idx + 'patternend'];
                        }

                        if (startCategory || endCategory) {
                            seriesObj.halfHash = true;
                        }
                        if (thisType === "column") {
                            seriesObj.columns.template.adapter.add("fill", function (fill, target) {
                                let dynamicStart = bocAmchart4.vars[chart.bocSettings.id]['series' + idx + 'patternstart'];

                                let dimensionKey = chart.bocSettings.dataProcessor.dimension ? "category" : "date";
                                let revertToColor = false;
                                if (dimensionKey === 'date') {
                                    if (startCategory && target.dataItem.dataContext['date'] < dynamicStart) {
                                        revertToColor = true;
                                    }
                                    if (endCategory && target.dataItem.dataContext['date'] > endCategory) {
                                        revertToColor = true;
                                    }
                                } else {
                                    if (startCategory) {
                                        let startIndex = chart.xAxes.getIndex(0).categoryToIndex(startCategory);
                                        let currentIndex = chart.xAxes.getIndex(0).categoryToIndex(target.dataItem.dataContext['category']);
                                        if (currentIndex < startIndex) {
                                            revertToColor = true;
                                        }
                                    }
                                }

                                return revertToColor ? thisColor : fill;
                            });
                        }
                    }
                }
            }
            if (thisType === "column" || thisType === "candlestick") {
                // COLUMN WIDTH //
                let columnWidth = false;
                // Check for series-specific column width, global column width, then use default
                if (thisColumnWidth) {
                    columnWidth = thisColumnWidth;
                } else if (chart.bocSettings.args.hasOwnProperty('columnwidth')) {
                    columnWidth = parseFloat(chart.bocSettings.args['columnwidth']);
                } else {
                    columnWidth = 95;
                }

                columnWidth = parseFloat(columnWidth);
                // If column width is defined in fractions, convert it to percentages
                if (columnWidth <= 1) {
                    columnWidth = columnWidth * 100;
                }
                // Set width and height (for horizontal columns)
                seriesObj.columns.template.width = am4core.percent(columnWidth);
                seriesObj.columns.template.height = am4core.percent(columnWidth);

                // GROUP SPACING //
                let groupSpacing = false;
                if (chart.bocSettings.args.hasOwnProperty('groupspacing')) {
                    groupSpacing = parseFloat(chart.bocSettings.args['groupspacing']);

                    // Convert spacing value to float if necessary
                    if (groupSpacing > 1) {
                        groupSpacing /= 100;
                    }

                    //Calculate start and end location floats
                    let cellStart = groupSpacing / 2;
                    let cellEnd = 1 - cellStart;

                    // Update start and end locations for groups on both axes
                    let xAxisRender = chart.xAxes.getIndex(0).renderer;
                    let yAxisRender = chart.yAxes.getIndex(0).renderer;
                    xAxisRender.cellStartLocation = cellStart;
                    xAxisRender.cellEndLocation = cellEnd;
                    yAxisRender.cellStartLocation = cellStart;
                    yAxisRender.cellEndLocation = cellEnd;
                }
            }
            if (thisType === 'line' || thisType === 'marker' || thisType === 'column') {
                bocAmchart4.initChartVars(chart);
                bocAmchart4.vars[chart.bocSettings.id].dashed = bocAmchart4.vars[chart.bocSettings.id].dashed || {};
                let dashed = {};
                let aliases = {
                    "projection": 6,
                    "dash": 6,
                    "average": 2,
                    "dot": 2
                };

                let dashArray = false;
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'dashlength')) {
                    dashArray = chart.bocSettings.args['series' + idx + 'dashlength'];
                }

                // Leaving dashLength as fallback to support transition
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'linestyle')) {
                    dashArray = chart.bocSettings.args['series' + idx + 'linestyle'];
                }
                if (aliases.hasOwnProperty(dashArray)) {
                    dashArray = aliases[dashArray];
                }

                if (dashArray) {
                    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'dashstart')) {
                        seriesObj.propertyFields.strokeDasharray = series + "_dashLength";
                        dashed["start"] = chart.bocSettings.args['series' + idx + 'dashstart'];
                        if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'dashend')) {
                            dashed["end"] = chart.bocSettings.args['series' + idx + 'dashend'];
                        }
                        dashed["length"] = dashArray;

                        bocAmchart4.vars[chart.bocSettings.id].dashed[series] = dashed;
                        seriesObj.dashLengthSwitched = true;
                    } else {
                        seriesObj.properties.strokeDasharray = dashArray;
                    }
                }
            }

            if (thisType === "scatter" || thisType === "bullet" || thisType === "marker") {
                bocAmchart4.initChartVars(chart);
                let shapeIndex = bocAmchart4.vars[chart.bocSettings.id].bulletIndex || 0;

                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'shapeindex')) {
                    shapeIndex = chart.bocSettings.args['series' + idx + 'shapeindex'];
                }

                if (shapeIndex >= shapes.length) {
                    shapeIndex = 0;
                }

                /**
                 * @type {am4charts.Bullet}
                 */
                let bullet = seriesObj.bullets.push(new am4charts.Bullet());

                let shape = bullet.createChild(am4core[shapes[shapeIndex].class]);

                if (shapes[shapeIndex].hasOwnProperty('size')) {
                    shape.width = shapes[shapeIndex].size;
                    shape.height = shapes[shapeIndex].size;
                }

                if (thisType === 'scatter' || thisType === 'marker') {
                    shape.radius = 4;
                }
                if (thisType === "bullet") {
                    shape.strokeWidth = 2;
                    shape.stroke = chart.colors.getIndex(51);
                    shape.radius = 8;
                    shape.width = shape.width * 2;
                    shape.height = shape.height * 2;
                }
                if (shapes[shapeIndex].hasOwnProperty('rotation')) {
                    shape.rotation = shapes[shapeIndex].rotation;
                }
                if (shapes[shapeIndex].hasOwnProperty('stroke')) {
                    shape.stroke = shapes[shapeIndex].stroke;
                }
                if (shapes[shapeIndex].hasOwnProperty('strokeWidth')) {
                    shape.strokeWidth = shapes[shapeIndex].strokeWidth;
                }

                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'bulletsize')) {
                    shape.radius = chart.bocSettings.args['series' + idx + 'bulletsize'];
                    shape.width = shape.radius;
                    shape.height = shape.radius;
                }

                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'bulletsizefield')) {
                    shape.propertyFields.radius = chart.bocSettings.args['series' + idx + 'bulletsizefield'];
                }

                let bulletLabel = false;
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labelfield')) {
                    bulletLabel = seriesObj.bullets.push(new am4charts.LabelBullet());
                    bulletLabel.label.text = "{" + chart.bocSettings.args['series' + idx + 'labelfield'] + "}";
                }
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labeltext')) {
                    bulletLabel = seriesObj.bullets.push(new am4charts.LabelBullet());
                    let labelText = chart.bocSettings.args['series' + idx + 'labeltext'];
                    bulletLabel.label.text = bocAmchart4.processStyleTags(labelText);
                }

                if (bulletLabel) {
                    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labelmaxwidth')) {
                        bulletLabel.label.maxWidth = parseInt(chart.bocSettings.args['series' + idx + 'labelmaxwidth']);
                        bulletLabel.label.wrap = true;
                        bulletLabel.label.truncate = false;
                        bulletLabel.label.textAlign = "middle";
                    }
                    if (chart.bocSettings.args.hasOwnProperty('serieslabelsfontsize')) {
                        bulletLabel.label.fontSize = parseInt(chart.bocSettings.args['serieslabelsfontsize']);
                    }
                    let position = "top";
                    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labelposition')) {
                        position = chart.bocSettings.args['series' + idx + 'labelposition'];
                    }
                    let dx = 0;
                    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labeldx')) {
                        dx = parseInt(chart.bocSettings.args['series' + idx + 'labeldx']);
                    }
                    let dy = 0;
                    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labeldy')) {
                        dy = parseInt(chart.bocSettings.args['series' + idx + 'labeldy']);
                    }

                    let labelColor = position === 'center' ? am4core.color("#fff") : chart.colors.getIndex(30);
                    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'labelcolor')) {
                        labelColor = am4core.color(chart.bocSettings.args['series' + idx + 'labelcolor']);
                    }
                    bulletLabel.label.fill = labelColor;

                    bocAmchart4.setObjectProperties(
                        bulletLabel.label,
                        'position',
                        position,
                        {
                            'top': {verticalCenter: "bottom", horizontalCenter: "middle", dy: dy - 5, dx: dx},
                            'bottom': {verticalCenter: "top", horizontalCenter: "middle", dy: dy + 5, dx: dx},
                            'left': {verticalCenter: "middle", horizontalCenter: "right", dy: dy + 1, dx: dx - 10},
                            'right': {verticalCenter: "middle", horizontalCenter: "left", dy: dy + 1, dx: dx + 10},
                            'center': {verticalCenter: "middle", horizontalCenter: "middle", dy: dy + 1, dx: dx}
                        }
                    );
                }

                shape.horizontalCenter = "middle";
                shape.verticalCenter = "middle";

                bullet.tooltipText = toolTipObj.tooltipText;

                bocAmchart4.vars[chart.bocSettings.id].bulletIndex = ++shapeIndex;
            }

            if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'tooltiptext')) {
                let tooltipText = chart.bocSettings.args['series' + idx + 'tooltiptext'];
                toolTipObj.tooltipText = bocAmchart4.processStyleTags(tooltipText);
            } else if (chart.bocSettings.args.hasOwnProperty('disabletooltips')
                && chart.bocSettings.args.disabletooltips === 'true') {
                toolTipObj.tooltipText = "";
            }

            if (chart.bocSettings.args.hasOwnProperty("series" + idx + "trendfield")) {
                let trendObj = chart.series.push(new am4charts.LineSeries());
                let trendSeries = chart.bocSettings.args["series" + idx + "trendfield"];
                // Need to change this based on chart type, if not date
                if (xAxisType === "date") {
                    trendObj.dataFields.dateX = "date";
                } else if (xAxisType === "text") {
                    trendObj.dataFields.categoryX = "category";
                } else if (xAxisType === "number") {
                    if (typeof series === 'object') {
                        if (yAxisType === 'text') {
                            trendObj.dataFields.valueX = trendSeries;
                        } else {
                            trendObj.dataFields.valueX = series[0];
                        }
                    } else {
                        trendObj.dataFields.valueX = trendSeries;
                    }
                } else {
                    // should not really get here, but let's keep it for now
                    trendObj.dataFields.valueX = xAxisType;
                }

                if (yAxisType === "date") {
                    trendObj.dataFields.dateY = "date";
                } else if (yAxisType === "text") {
                    trendObj.dataFields.categoryY = "category";
                } else if (yAxisType === "number") {
                    if (thisType !== 'candlestick' && thisType !== 'band') {
                        if (typeof series === 'object') {
                            trendObj.dataFields.valueY = trendSeries;
                        } else {
                            trendObj.dataFields.valueY = trendSeries;
                        }
                    }
                }
                trendObj.fill = seriesObj.fill;
                trendObj.stroke = seriesObj.stroke;
                trendObj.properties.strokeDasharray = 2;
                seriesObj.trendLine = trendObj;

                trendObj.hiddenInLegend = true;
                seriesObj.events.on("hidden", function (event) {
                    event.target.trendLine.hide();
                });
                seriesObj.events.on("shown", function (event) {
                    event.target.trendLine.show();
                });

                if (bocAmchart4.debug(chart)) {
                    // eslint-disable-next-line no-console
                    console.log(
                        chart.bocSettings.id,
                        "Added trend line:",
                        bocAmchart4.debugClone(trendObj)
                    );
                }
            }


            if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'location')) {
                let location = parseFloat(chart.bocSettings.args['series' + idx + 'location']);
                if (xAxisType === 'text') {
                    seriesObj.dataItems.template.locations.categoryX = location;
                } else if (yAxisType === 'text') {
                    seriesObj.dataItems.template.locations.categoryY = location;
                }
            }

            if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'errorminfield')
                && chart.bocSettings.args.hasOwnProperty('series' + idx + 'errormaxfield')) {
                seriesObj.dataFields.lowValueY = chart.bocSettings.args['series' + idx + 'errorminfield'];
                seriesObj.dataFields.highValueY = chart.bocSettings.args['series' + idx + 'errormaxfield'];

                var errorBullet = seriesObj.bullets.push(new am4charts.ErrorBullet());
                errorBullet.valueYField = series[1];
                errorBullet.errorYField = series[1];

                let errorColor;
                if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'errorcolor')) {
                    errorColor = chart.bocSettings.args['series' + idx + 'errorcolor'];
                    if (errorColor.slice(0, 1) === '#') {
                        errorColor = am4core.color(errorColor);
                    } else if (!isNaN(errorColor) && chart.colors.list[parseInt(errorColor)]) {
                        errorColor = chart.colors.list[parseInt(errorColor)];
                    }
                } else {
                    if (thisType === 'column' || thisType === 'fill' || thisType === 'candlestick') {
                        errorColor = chart.colors.list[30];
                    } else {
                        errorColor = thisColor;
                    }
                }

                errorBullet.stroke = errorColor;
                errorBullet.strokeOpacity = 0.8;
                errorBullet.strokeWidth = 2;

                var errorLine = errorBullet.createChild(am4core.Line);
                errorLine.strokeOpacity = 0.8;
                errorLine.stroke = errorColor;
                errorLine.strokeWidth = 2;
                errorLine.isMeasured = false;

                errorBullet.adapter.add("pixelHeight", function (pixelHeight, target) {
                    var dataItem = target.dataItem;
                    if (dataItem) {
                        var highValueY = parseFloat(dataItem.highValueY);
                        var lowValueY = parseFloat(dataItem.lowValueY);
                        var valueYLow = chart.yAxes.getIndex(0).valueToPoint(lowValueY).y;
                        var valueYHigh = chart.yAxes.getIndex(0).valueToPoint(highValueY).y;
                        return valueYHigh - valueYLow;
                    }
                    return pixelHeight;
                });

                errorBullet.adapter.add("dy", function (dy, target) {
                    var dataItem = target.dataItem;
                    if (dataItem) {
                        var errorTopValue = parseFloat(dataItem.highValueY);
                        var errorBottomValue = parseFloat(dataItem.lowValueY);
                        var errorCenterValue = parseFloat(dataItem.valueY);
                        var errorBottomY = chart.yAxes.getIndex(0).valueToPoint(errorBottomValue).y;
                        var errorTopY = chart.yAxes.getIndex(0).valueToPoint(errorTopValue).y;
                        var errorCenterY = chart.yAxes.getIndex(0).valueToPoint(errorCenterValue).y;

                        return (errorTopY - errorCenterY) / 2 - (errorCenterY - errorBottomY) / 2;
                    }
                    return dy;
                });
            }

            break;
        }
        case 'pie': {
            //initialization of the core pie chart
            seriesObj = chart.series.push(new am4charts.PieSeries());
            seriesObj.dataFields.value = series;
            seriesObj.dataFields.category = "category";
            seriesObj.labels.template.disabled = true;
            seriesObj.ticks.template.disabled = true;

            //setting the tooltip template as 90.0%
            let localizedText = "{category}: {value.percent.formatNumber('##.0')}%";
            if (chartLanguage === "fr") {
                localizedText = "{category} : {value.percent.formatNumber('##.0')} %";
            }
            seriesObj.slices.template.tooltipText = localizedText;

            //collecting all instances of parameters that are relevant to series color and series tooltiptext
            let seriesArgs = Object.keys(chart.bocSettings.args)
                .filter(key => key.startsWith('series'))
                .reduce((res, key) => ((res[key] = chart.bocSettings.args[key]), res), {});

            let argNames = Object.keys(seriesArgs);

            //disabling the hover and click effects
            let slice = seriesObj.slices.template;
            slice.states.getKey("hover").properties.scale = 1;
            slice.states.getKey("active").properties.shiftRadius = 0;
            if (!chart.bocSettings.args.hasOwnProperty("forcepie") || chart.bocSettings.args['forcepie'] !== 'true') {
                bocAmchart4.applyDoughnut(chart);
            }
            if (!chart.bocSettings.args.hasOwnProperty('hidepielabels') || chart.bocSettings.args['hidepielabels'] !== 'true') {
                //if hidepielabels isn't true, either the value is false, null or a numerical value
                //if there is a value with hidepielabels, and it is a number, then make that number the breakpoint for the labels to hide
                //otherwise, if the value is not a number, then it is null or false and we should not display labgels
                let hideWidth = chart.bocSettings.args.hasOwnProperty('hidepielabels') && !isNaN(chart.bocSettings.args['hidepielabels']) ? parseInt(chart.bocSettings.args['hidepielabels']) : false;
                chart.events.once('validated', () => {
                    bocAmchart4.labelDoughnut(chart);
                });

                chart.events.on('sizechanged', (event) => {
                    //if a custom width has not been provided, then compute when the labels are outside the container and hide them when they are
                    bocAmchart4.labelDoughnut(chart);
                    bocAmchart4.computeDisplayPieLabels(chart, event, hideWidth);
                });
            }
            seriesObj.events.on('beforevalidated', () => {
                let computedSeries = [];

                for (let ind = 0; ind < argNames.length; ind++) {
                    let idxString = argNames[ind].slice(6, argNames[ind].length);
                    if (!idxString || !idxString.match(/\d+/)) {
                        continue;
                    }
                    let seriesIdx = parseInt(idxString.match(/\d+/)[0]);

                    //if we have already considered this seriesIndex, skip its relevant parameters
                    if (seriesIdx in computedSeries) {
                        continue;
                    }

                    /**
                     * A conditional to replace the functionality of the 'data-series{0|1|..}color' on pie charts to instead be slice color
                     * see params documentation for data-series{0|1|..}color for further clarification
                     */
                    if (chart.bocSettings.args.hasOwnProperty('series' + seriesIdx + 'color')) {
                        //if the user is trying to ask for a series index > the number of slices, return {void}
                        if (seriesIdx > seriesObj.dataItems.length) {
                            return;
                        }
                        let thisColor = chart.bocSettings.args['series' + seriesIdx + 'color'];
                        //this will first check if the user has input a hexcode, or a valid index in the colours array. If neither of those things, default to the order in the colours array.
                        if (thisColor) {
                            if (thisColor.slice(0, 1) === '#') {
                                thisColor = am4core.color(thisColor);
                            } else if (!isNaN(thisColor) && chart.colors.list[parseInt(thisColor)]) {
                                thisColor = chart.colors.list[parseInt(thisColor)];
                            } else {
                                thisColor = false;
                            }
                            if (thisColor) {
                                let thisSlice = seriesObj.dataItems.getIndex(seriesIdx).slice;
                                thisSlice.fill = thisColor;
                                thisSlice.stroke = thisColor;
                            }
                        }
                    }

                    // PARAMETER data-seriesXopacity
                    if (chart.bocSettings.args.hasOwnProperty('series' + seriesIdx + 'opacity')) {
                        // update series opacity
                        let thisSlice = seriesObj.dataItems.getIndex(seriesIdx).slice;
                        thisSlice.fillOpacity = chart.bocSettings.args['series' + seriesIdx + 'opacity'];
                        thisSlice.strokeWidth = 0;
                        // update legend marker opacity (if markers have loaded)
                        if (chart.legend.markers.length > 0) {
                            const marker = chart.legend.markers.getIndex(seriesIdx);
                            marker.fillOpacity = chart.bocSettings.args['series' + seriesIdx + 'opacity'];
                            marker.strokeWidth = 0;
                        }
                    }
                    computedSeries.push(seriesIdx);
                }
            });
            seriesObj.events.on('validated', () => {
                //an array to keep track of which seriesIndices we have considered already
                let computedSeries = [];
                //for each parameter get the number directly following the string 'series'
                for (let ind = 0; ind < argNames.length; ind++) {
                    //idxString is the remainder of the string from the argument name. (e.g. color, tooltipText)
                    let idxString = argNames[ind].slice(6, argNames[ind].length);
                    if (!idxString || !idxString.match(/\d+/)) {
                        continue;
                    }
                    let seriesIdx = parseInt(idxString.match(/\d+/)[0]);

                    //if we have already considered this seriesIndex, skip its relevant parameters
                    if (seriesIdx in computedSeries) {
                        continue;
                    }

                    /**
                     * A conditional to replace the functionality of the 'data-series{0|1|..}tooltiptext' on pie charts to instead replace the tooltip on the slices instead of series
                     * see params documentation for data-series{0|1|..}tooltiptext for further clarification
                     */
                    if (chart.bocSettings.args.hasOwnProperty('series' + seriesIdx + 'tooltiptext')) {
                        //if the user is trying to ask for a series index > the number of slices, return {void}
                        if (seriesIdx > seriesObj.dataItems.length) {
                            return;
                        }
                        let thisSlice = seriesObj.dataItems.getIndex(seriesIdx).slice;
                        thisSlice.tooltipText = chart.bocSettings.args['series' + seriesIdx + 'tooltiptext'];
                    } else if (chart.bocSettings.args.hasOwnProperty('disabletooltips')
                        && chart.bocSettings.args.disabletooltips === 'true') {
                        seriesObj.slices.template.tooltipText = "";
                    }

                    /**
                     * A conditional to replace the labels associated with both the pointer to the chart and the legend
                     * see params documentation for data-series{0|1|..}legendtext for further clarification
                     */
                    if (chart.bocSettings.args.hasOwnProperty('series' + seriesIdx + 'legendtext')) {
                        if (seriesIdx > seriesObj.dataItems.length) {
                            return;
                        }
                        //update the text of the label pointing at the slice
                        let categoryLabel = chart.series.getIndex(0).labels;
                        if (!categoryLabel) {
                            return;
                        }
                        categoryLabel.text = chart.bocSettings.args['series' + seriesIdx + 'legendtext'];

                        //update the text of the legend associated with the category
                        let categoryLegendLabel = chart.legend.dataItems.getIndex(seriesIdx);
                        if (!categoryLegendLabel) {
                            return;
                        }
                        categoryLegendLabel.label.text = chart.bocSettings.args['series' + seriesIdx + 'legendtext'];
                    }
                    //adding in this series to the list of computed series, as to not repeat these conditionals
                    computedSeries.push(seriesIdx);
                }
            });
            thisType = 'slice';
            break;
        }
        case 'map': {
            seriesObj = chart.series.push(new am4maps.MapPolygonSeries());
            seriesObj.useGeodata = true;
            seriesObj.exclude = ["AQ"];
            seriesObj.dataFields.value = series;

            let polygonTemplate = seriesObj.mapPolygons.template;
            polygonTemplate.tooltipText = "{name} {value}";

            if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'tooltiptext')) {
                polygonTemplate.tooltipText = chart.bocSettings.args['series' + idx + 'tooltiptext'];
            }

            polygonTemplate.fill = am4core.color("#aaa");

            bocAmchart4.initChartVars(chart);
            bocAmchart4.vars[chart.bocSettings.id].mainColors = [];
            bocAmchart4.vars[chart.bocSettings.id].allColors = [];

            bocAmchart4.getColorsFromShortcode(chart);
            bocAmchart4.getBucketsFromShortcode(chart);

            if (chart.bocSettings.args.hasOwnProperty("markercount") && Number(chart.bocSettings.args.markercount) > 1) {
                seriesObj.mapPolygons.template.adapter.add("fill", function (fill, target) {
                    return bocAmchart4.calculateMapColors(chart, fill, target);
                });
            } else {
                bocAmchart4.defaultMapLegend(chart, seriesObj, polygonTemplate);
            }
            thisType = 'region';
            break;
        }
    }
    seriesObj.tooltip.getFillFromObject = false;
    seriesObj.tooltip.getStrokeFromObject = true;
    seriesObj.tooltip.fontSize = "0.875em";
    seriesObj.tooltip.label.fill = chart.colors.getIndex(30);
    seriesObj.tooltip.label.wrap = true;
    seriesObj.tooltip.label.truncate = false;

    if (chart.cursor && (xAxisType === "time" || xAxisType === "number") && seriesObj.tooltipText) {
        if (!chart.cursor.snapToSeries) {
            chart.cursor.snapToSeries = [seriesObj];
        } else {
            chart.cursor.snapToSeries.push(seriesObj);
        }
    }

    chart.events.on('sizechanged', function (event) {
        seriesObj.tooltip.label.maxWidth = event.target.contentWidth / 2;
    });

    //Check if some defaults need to be overridden based on type
    if (defaults.hasOwnProperty(thisType)) {
        for (let prop in defaults[thisType]) {
            if (defaults[thisType].hasOwnProperty(prop)) {
                seriesObj[prop] = defaults[thisType][prop];
            }
        }
    }

    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'hidden')
        && chart.bocSettings.args['series' + idx + 'hidden'] === 'true') {
        seriesObj.hide();
        seriesObj.originallyHidden = true;
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'hidden')
        && chart.bocSettings.args['series' + idx + 'hidden'] === 'legend') {
        chart.events.once('validated', function () {
            seriesObj.hiddenInLegend = true;
        });
    }


    if (chart.bocSettings.args.hasOwnProperty('series' + idx + 'legendsync')) {
        chart.events.once('validated', function () {
            seriesObj.hiddenInLegend = true;
        });
        let syncSeries = chart.series.getIndex(parseInt(chart.bocSettings.args['series' + idx + 'legendsync']));
        syncSeries.events.on("hidden", function () {
            seriesObj.hide();
        });
        syncSeries.events.on("shown", function () {
            seriesObj.show();
        });
    }

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Pushed graph:",
            bocAmchart4.debugClone(seriesObj)
        );
    }
};

/**
 * @param {string|int} colorIndex Either index of the color, or the string of the hex color
 * @param {string} patternType - one of the predefined string ids
 * @param {float} opacity of the pattern
 * @param {float} width of the pattern
 * @param {float} height of the pattern
 * @returns {object} Returns a Pattern object
 */
bocAmchart4.getPattern = function (colorIndex, patternType, opacity) {
    // default to gray color
    let color = "#888888";
    if (isNaN(colorIndex)) {
        color = colorIndex;
    } else {
        if (AmCharts.themes[bocAmchart4.theme].AmCoordinateChart.colors !== 'undefined') {
            color = AmCharts.themes[bocAmchart4.theme].AmCoordinateChart.colors[colorIndex];
        }
    }
    if (typeof opacity === 'undefined') {
        opacity = 1;
    }
    let pattern;
    let patternDescription = patternType.split('-');
    switch (patternDescription[0]) {
        case "stripes":
            pattern = new am4core.LinePattern();
            pattern.strokeWidth = 2.5;
            pattern.gap = 2.5;
            //A small offset of 0.1deg to fix issue with rendering vertical pattern on fill type charts
            if (isNaN(parseInt(patternDescription[1]))) {
                pattern.rotation = patternDescription[1] === 'horizontal' ? 0 : 90;
            } else {
                pattern.rotation = parseInt(patternDescription[1]);
            }
            if (pattern.rotation === 0) {
                pattern.width = 16;
                pattern.height = 10;
            } else {
                pattern.width = 10;
                pattern.height = 16;
            }
            break;
        default:
            pattern = new am4core.LinePattern();
            pattern.strokeWidth = 2.5;
            pattern.gap = 2.5;
            pattern.width = 21;
            pattern.height = 21;
            pattern.rotation = patternDescription[1] === 'down' ? 45 : -45;
            if (patternDescription[1] === 'fine') {
                pattern.strokeWidth = 1.5;
                pattern.gap = 1.5;
            }
    }
    pattern.stroke = am4core.color(color);
    //Width and Height chosen to be the largest of the two values to fully cover the area of the graph
    pattern.strokeOpacity = opacity;
    pattern.shapeRendering = "optimizeSpeed";
    return pattern;
};

bocAmchart4.getBocSetting = function (chart, seriesAttribute, index, defaultValue) {
    if (chart.bocSettings.args.hasOwnProperty('series' + index + seriesAttribute)) {
        defaultValue = chart.bocSettings.args['series' + index + seriesAttribute];
    }
    return defaultValue;
};
